module.exports = __webpack_public_path__ + "static/fonts/icons.718106a.woff";


//////////////////
// WEBPACK FOOTER
// ./autocomplete-component/dist/src/fonts/icons.woff
// module id = UYLg
// module chunks = 1